module.exports = __webpack_public_path__ + "static/media/tanker.f56d56d8.svg";